import React from "react";
import { Link } from "react-router-dom";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";
import "./ChatAnalytics.css";

const DUMMY_PLAYERS = [
  { name: "Marcus Johnson", sessions: 24, activeDays: 12 },
  { name: "Jordan Williams", sessions: 18, activeDays: 9 },
  { name: "Tyler Davis", sessions: 15, activeDays: 8 },
  { name: "Chris Miller", sessions: 11, activeDays: 6 },
  { name: "Alex Thompson", sessions: 8, activeDays: 5 },
];

const DUMMY_FAQ = [
  { question: "Why was I graded this way on that rep?", count: 34 },
  { question: "What should I fix first?", count: 28 },
  { question: "How do I earn more reps?", count: 22 },
  { question: "What did the coach mean by ‘eyes right’?", count: 18 },
  { question: "When is film review?", count: 14 },
];

const DUMMY_TOPICS = [
  { label: "Feedback / grades", count: 42, pct: 100 },
  { label: "Technique", count: 31, pct: 74 },
  { label: "Film / assignments", count: 24, pct: 57 },
  { label: "General questions", count: 18, pct: 43 },
];

const DUMMY_ENGAGEMENT = [
  { week: "Jan 6", messages: 48 },
  { week: "Jan 13", messages: 62 },
  { week: "Jan 20", messages: 55 },
  { week: "Jan 27", messages: 71 },
  { week: "Feb 3", messages: 89 },
  { week: "Feb 10", messages: 102 },
];

const ChatAnalytics = () => (
  <div className="chat-analytics">
    <div className="chat-analytics-header">
      <div className="chat-analytics-header-top">
        <div>
          <Link to="/ai-coach-setup" className="chat-analytics-back">← AI Coach Setup</Link>
          <h1 className="chat-analytics-title">Chat Analytics</h1>
          <p className="chat-analytics-subtitle">
            See how your players interact with the AI Coach: questions asked, topics discussed, and engagement over time.
          </p>
        </div>
        <div className="chat-analytics-badge">Coming soon</div>
      </div>
    </div>


    <div className="chat-analytics-cta mb-[24px]">
      <p className="chat-analytics-cta-text">This is a preview with sample data. The real dashboard will use your team’s AI Coach usage.</p>
      <p className="chat-analytics-cta-sub">You’ll be notified when it’s ready.</p>
    </div>


    <div className="chat-analytics-dashboard">
      <section className="chat-analytics-card chat-analytics-section">
        <h3 className="chat-analytics-section-title">Player usage</h3>
        <p className="chat-analytics-section-desc">Sessions and active days (sample data)</p>
        <div className="chat-analytics-table-wrap">
          <table className="chat-analytics-table">
            <thead>
              <tr>
                <th>Player</th>
                <th>Sessions</th>
                <th>Active days</th>
              </tr>
            </thead>
            <tbody>
              {DUMMY_PLAYERS.map((row, i) => (
                <tr key={i}>
                  <td>{row.name}</td>
                  <td>{row.sessions}</td>
                  <td>{row.activeDays}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="chat-analytics-card chat-analytics-section">
        <h3 className="chat-analytics-section-title">Frequently asked questions</h3>
        <p className="chat-analytics-section-desc">Top questions players ask the AI (sample data)</p>
        <ul className="chat-analytics-faq-list">
          {DUMMY_FAQ.map((item, i) => (
            <li key={i} className="chat-analytics-faq-item">
              <span className="chat-analytics-faq-q">{item.question}</span>
              <span className="chat-analytics-faq-count">{item.count} asks</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="chat-analytics-card chat-analytics-section chat-analytics-section--wide">
        <h3 className="chat-analytics-section-title">Topics & trends</h3>
        <p className="chat-analytics-section-desc">What players talk about (sample data)</p>
        <div className="chat-analytics-bars">
          {DUMMY_TOPICS.map((t, i) => (
            <div key={i} className="chat-analytics-bar-row">
              <span className="chat-analytics-bar-label">{t.label}</span>
              <div className="chat-analytics-bar-track">
                <div className="chat-analytics-bar-fill" style={{ width: `${t.pct}%` }} />
              </div>
              <span className="chat-analytics-bar-value">{t.count}</span>
            </div>
          ))}
        </div>
      </section>

      <section className="chat-analytics-card chat-analytics-section chat-analytics-section--wide">
        <h3 className="chat-analytics-section-title">Engagement over time</h3>
        <p className="chat-analytics-section-desc">Chat messages per week (sample data)</p>
        <div className="chat-analytics-chart-wrap">
          <ResponsiveContainer width="100%" height={220}>
            <AreaChart data={DUMMY_ENGAGEMENT} margin={{ top: 8, right: 8, left: 0, bottom: 0 }}>
              <defs>
                <linearGradient id="caGradient" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#0071e3" stopOpacity={0.3} />
                  <stop offset="100%" stopColor="#0071e3" stopOpacity={0} />
                </linearGradient>
              </defs>
              <XAxis dataKey="week" tick={{ fontSize: 11 }} stroke="#86868b" />
              <YAxis tick={{ fontSize: 11 }} stroke="#86868b" allowDecimals={false} />
              <Tooltip
                contentStyle={{ borderRadius: 8, fontSize: 12 }}
                formatter={(value) => `${value} messages`}
                labelFormatter={(label) => `Week of ${label}`}
              />
              <Area type="monotone" dataKey="messages" stroke="#0071e3" strokeWidth={2} fill="url(#caGradient)" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </section>
    </div>

  
  </div>
);

export default ChatAnalytics;
